import type { ReactNode } from "react";

export function OkrsPageHeader(props: {
  action?: ReactNode | undefined;
  description: string;
  title: string;
}) {
  return (
    <header className="flex flex-wrap items-start justify-between gap-3">
      <div className="space-y-1">
        <h2 className="text-base font-semibold tracking-tight text-foreground">{props.title}</h2>
        <p className="text-sm text-muted-foreground">{props.description}</p>
      </div>
      {props.action}
    </header>
  );
}
